<!-- @format -->

<template>
    <div class="gst-hotels-info-panel-replace">
        <div class="gst-hotels-info-panel-replace__inner">
            <h6 class="mb-1">{{ $t('title') }}</h6>
            <p class="mb-0">{{ $t('description') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HotelsInfoPanelReplace',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking._components.hotelsInfoPanelReplace',
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-hotels-info-panel-replace__inner {
    line-height: normal;
    padding: theme-spacing(3);
    background-color: rgba(theme-color-hex('secondary'), 0.1);

    @include mobile-only {
        font-size: 13px;

        h6 {
            font-size: 13px;
        }
    }
}
</style>
